





































import Component, { mixins } from "vue-class-component";
import { Currency } from "@teacherskaya/api-provider/dist/api/CurrencyProvider";
import WithPaymentSystems from "@/mixins/WithPaymentSystems";
import WithCurrency from "@/mixins/WithCurrency";
import WithLoadingStatus from "@/mixins/WithLoadingStatus";
import BaseSlowConnection from "@/components/BaseSlowConnection";
import WrapperCheckAuthorities from "@/components/WrapperCheckAuthorities.vue";
import BasePageTwoColumn from "@/components/BasePageTwoColumn.vue";
import PageTitle from "@/components/PageTitle.vue";
import BlockPaymentSystem from "./components/BlockPaymentSystem.vue";
import PaymentsRightCol from "./PaymentsRightCol.vue";

@Component({
  name: "PageSettingsPaymentSystems",
  components: {
    PageTitle,
    PaymentsRightCol,
    BasePageTwoColumn,
    BlockPaymentSystem,
    WrapperCheckAuthorities,
    BaseSlowConnection,
  },
})
export default class PageSettingsPaymentSystems extends mixins(
  WithPaymentSystems,
  WithCurrency,
  WithLoadingStatus,
) {
  public isLoading: boolean = true;

  public currencyList: Currency[] = [];

  public created() {
    this.loadingStatusShow([
      this.paymentSystemsFindAll(),
      this.currencyFindAll().then((response: Currency[]) => {
        this.currencyList = response;
      }),
    ]).then(() => {
      this.isLoading = false;
    });
  }
}
